export default {
  NEW_DOSSIER: 'NEW_DOSSIER',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  WAIT_ACCOUNT_AGGREGATION: 'WAIT_ACCOUNT_AGGREGATION',
  ACCOUNTS_CONFIRMATION: 'ACCOUNTS_CONFIRMATION',
  WAIT_PREAPPROVAL_DATA: 'WAIT_PREAPPROVAL_DATA',
  MODELLICA_1: 'MODELLICA_1',
  M1_COUNTEROFFER: 'M1_COUNTEROFFER',
  PRE_APPROVED: 'PRE_APPROVED',
  DENIED: 'DENIED',
  CANCELLED: 'CANCELLED',
  WAIT_RNC_DATA: 'WAIT_RNC_DATA',
  FIOC: 'FIOC',
  IBAN_CHECK: 'IBAN_CHECK',
  WAIT_DOCUMENTS: 'WAIT_DOCUMENTS',
  WAIT_OTP: 'WAIT_OTP',
  STANDBY: 'STANDBY',
  M2_COUNTEROFFER: 'M2_COUNTEROFFER',
  APPROVED: 'APPROVED',
  USER_DELETION: 'USER_DELETION',
  USER_DELETION_RETRY: 'USER_DELETION_RETRY',
  CONTRACTING: 'CONTRACTING',
  SIGNING: 'SIGNING',
  SIGNED: 'SIGNED',
  TRANSFER_OK: 'TRANSFER_OK',
  LOAN_COMPLETE: 'LOAN_COMPLETE',
}